import api from '@/services/api/audit.js'
import { immerable } from 'immer'
import { useState, useRef } from 'react'
import KeyHelper from '@/utils/key-helper'

class Audit {

	[immerable] = true

	constructor(params) {
		this.id = params.id
		this.type = params.type
		this.event = params.event
		this.via = params.via
		this.status = params.status
		this.timestamp = params.timestamp
		this.userId = params.userId
		this.message = params.message
		this.data = params.data
		this.related = params.related
		this.$selected = false
	}
}

const useAudit = () => {

	const [itemsData, setItems] = useState([])
	const [metaData, setMeta] = useState(null)
	const [currentItem, setCurrentItem] = useState(null)
	const [loading, setLoading] = useState(false)
	const [errorMsg, setErrorMsg] = useState()

	const lastRequestPayloadKeyRef = useRef(null)

	async function fetch(parameter) {
		const currentPayloadKey = KeyHelper.createKeyOfObject({ parameter })

		if(KeyHelper.isSameKey(lastRequestPayloadKeyRef.current, currentPayloadKey)) return;

		lastRequestPayloadKeyRef.current = currentPayloadKey

		setLoading(true)

		const params = parameter ? parameter : "";

		const [error, response] = await api.index({
			params
		})

		setLoading(false)

		if (error) {
			return setErrorMsg(error)
		}

		const { items, meta } = response

		if (!Array.isArray(items)) {
			return setErrorMsg('Audit is not an array')
		}

		const serializedData = items.map(entry => serialize(entry))
		const newItems = serializedData.map(dataParams => new Audit(dataParams))

		setMeta(meta)
		setItems(newItems)
	}

	async function getAuditEnum() {

		setLoading(true)

		const [error, response] = await api.getAuditEnum()

		setLoading(false)

		if (error) {
			return setErrorMsg(error)
		}
		if (!response) {
			return setErrorMsg('Audit Enum is empty ')
		}

		function addSelected(array) {
			return array.map(item => { return { ...item, $selected: false } })
		}

		const type = addSelected(response.type)
		const via = addSelected(response.via)
		const status = addSelected(response.status)
		const event = addSelected(response.event)

		type[0].$selected = true

	

		return { type, via, status, event }

	}


	async function find(parameter) {

		setLoading(true)

		const params = parameter ? parameter : "";

		const [error, { items }] = await api.index({
			params
		})

		setLoading(false)

		if (error) {
			return setErrorMsg(error)
		}

		if (!Array.isArray(items)) {
			return setErrorMsg('Audit is not an array')
		}

		const serializedData = items.map(entry => serialize(entry))
		return serializedData.map(dataParams => new Audit(dataParams))
	}

	function serialize(entry) {
		return {
			id: entry.id,
			type: entry.type,
			event: entry.event,
			via: entry.via,
			status: entry.status,
			timestamp: entry.timestamp,
			userId: entry.userId,
			message: entry.message,
			data: entry.data,
			related: entry.related
		}
	}

	function view(id) {
		const newCurrentItem = itemsData.find(item => item.id === id)
		setCurrentItem(newCurrentItem)
	}

	return {
		currentItem,
		error: errorMsg,
		fetch,
		items:itemsData,
		loading,
		meta:metaData,
		setCurrentItem,
		setItems,
		view,
		find,
		getAuditEnum
	}

}

export default useAudit
